module.exports = __webpack_public_path__ + "images/backgrounds/ocean/full.4ce437330ab9d2fe40dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/ocean/full.jpg
// module id = S13S
// module chunks = 0